import { Fragment } from 'react';
import cx from 'classnames';

const getBackgroundColorCode = (colorSelection) => {
  switch (colorSelection) {
    case 'white':
      return 'bg-white';
    case 'green':
      return 'bg-green-700';
    case 'violet':
      return 'bg-violet-900';
    case 'pink':
      return 'bg-pink-700';
    case 'lightViolet':
      return 'bg-violet-100';
    default:
      return 'bg-neutral-200';
  }
};

const getPaddingClass = (paddingSelection) => {
  switch (paddingSelection) {
    case 'small':
      return 'pt-3';
    case 'medium':
      return 'pt-6';
    case 'large':
      return 'pt-8';
    default:
      return 'pt-2';
  }
};

const PaddedDivider = ({ entry }) => {
  const backgroundColor = getBackgroundColorCode(entry.backgroundColorSelection);
  const paddingClass = getPaddingClass(entry.verticalPadding);

  return (
      <div className={cx(paddingClass, backgroundColor)}/>
  );
};

export default PaddedDivider;
